import DispatchConstants from 'app/shared/constants/DispatchConstants';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

const initState = () => ({
    properties: [],
    competitionDataLoadingState: LoadingConstants.INITIAL,
});

const competition = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_PROPERTY_RENT_COMPARISON_GET_SUCCESS:
            return {
                ...state,
                properties: payload.properties,
                competitionDataLoadingState: LoadingConstants.SUCCESS,
            };
        case DispatchConstants.ANALYTICS_COMPETITION_SET_LOADING_STATE:
            return {
                ...state,
                competitionDataLoadingState: payload,
            };
        case DispatchConstants.ANALYTICS_COMPETITION_CLEAR:
            return initState();
        default:
            return state;
    }
};

export default competition;
